import { motion } from 'framer-motion';

type Props = {
  /** 0–100 */
  pct: number;
  filled: number;
  total: number;
};

// 270° arc with a 90° gap at the bottom. pathLength=100 lets us drive the
// fill straight from the percentage without measuring the path.
const ARC = 'M 43.4 156.6 A 80 80 0 1 1 156.6 156.6';

export function OccupancyGauge({ pct, filled, total }: Props) {
  const clamped = Math.max(0, Math.min(100, pct));
  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <svg
          viewBox="0 0 200 175"
          className="w-52"
          role="img"
          aria-label={`Doluluk %${clamped} — ${filled} / ${total} koltuk`}
        >
          <defs>
            <linearGradient id="occ-grad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0%" stopColor="var(--accent)" />
              <stop offset="100%" stopColor="var(--gold)" />
            </linearGradient>
          </defs>
          <path
            d={ARC}
            fill="none"
            stroke="var(--surface-elevated)"
            strokeWidth={14}
            strokeLinecap="round"
            pathLength={100}
          />
          <motion.path
            d={ARC}
            fill="none"
            stroke="url(#occ-grad)"
            strokeWidth={14}
            strokeLinecap="round"
            pathLength={100}
            strokeDasharray="100 100"
            initial={{ strokeDashoffset: 100 }}
            animate={{ strokeDashoffset: 100 - clamped }}
            transition={{ type: 'spring', stiffness: 60, damping: 18 }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center pt-3">
          <span className="font-display text-5xl leading-none tracking-tight tnum">
            {clamped}
            <span className="text-2xl text-text-muted">%</span>
          </span>
          <span className="mt-1 text-[10px] uppercase tracking-[0.18em] text-text-faint">
            Doluluk
          </span>
        </div>
      </div>
      <p className="mono mt-1 text-sm text-text-muted tnum">
        {filled} <span className="text-text-faint">/ {total} koltuk</span>
      </p>
    </div>
  );
}
